const FooterCopyright = () => {
    return (
        <div className="footer-bottom">
            <div className="row">
                <div className="column width-12">
                    <div className="footer-bottom-inner">
                        <p className="copyright pull-left clear-float-on-mobile">Copyright 2021 - 2024. <a target="_blank" href="https://www.wiselight.kr/">와이즈라이트</a> All rights reserved.</p> <a href="#" className="scroll-to-top pull-right clear-on-mobile"
                                             data-no-hide>Back Top</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterCopyright;